function createPath(path, locale) {
  const cleanPath = path.replace(/'/g, "%27");
  if (locale === void 0) {
    return cleanPath;
  }
  const localePath = `/${locale.replace("-", "_")}`;
  if (cleanPath === localePath) {
    return "/";
  }
  return cleanPath.includes(localePath) ? cleanPath.replace(localePath, "") : cleanPath;
}
export {
  createPath
};
//# sourceMappingURL=create-path.js.map
